module.exports = __webpack_public_path__ + "img/avatar-s-5.96ff7b64.jpg";